import { InputFieldData, InputStateProps } from '../../@types/input-field-data';

export const verifyObjectOnInput = (
  value: string | number | boolean | {},
  field: InputFieldData,
  onInput: InputStateProps['onInput']
) => {
  if (typeof value === 'object') {
    return onInput({ ...value });
  } else {
    return onInput({ [field.name || field.type]: value });
  }
};
